import { render, staticRenderFns } from "./uvDataTable.vue?vue&type=template&id=fa6546b6&scoped=true"
import script from "./uvDataTable.vue?vue&type=script&lang=js"
export * from "./uvDataTable.vue?vue&type=script&lang=js"
import style0 from "./uvDataTable.vue?vue&type=style&index=0&id=fa6546b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6546b6",
  null
  
)

export default component.exports